/**
 * Per-page-load memory of each list's search term, keyed by history entry.
 *
 * A list's search is deliberately kept out of the URL and out of persistent
 * storage so a refresh starts clean. But browser back/forward returns to the
 * *same* history entry (`location.key`) without reloading the page, and the
 * user expects the search that got them to the detail page to still be there,
 * exactly as the TopBar breadcrumb restores it. This module-level map lives only
 * as long as the JS runtime: SPA navigation keeps it, a refresh drops it.
 *
 * Lists keep it in step via `useRememberListSearch` (src/hooks).
 */
const memory = new Map<string, string>();

export function recallListSearch(locationKey: string): string | undefined {
    return memory.get(locationKey);
}

export function rememberListSearch(locationKey: string, search: string): void {
    memory.set(locationKey, search);
}
